import AgencyCodeRequestAdmin from "./codeRequests"

export { default as AgencyCodeRequestsPanel } from "./codeRequests.panel"
export default AgencyCodeRequestAdmin
